// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://api-dev.oremus.ci',
  reportUrl: 'https://report-dev.oremus.ci',
  appVersion: `${packageJson.version}-dev`,
  sentryDsn: 'https://7bfbce0e-616e-4734-aae3-cfef2796eae6@errors.ypy-it.com/1',
  sentryEnvironment: 'dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
